/** Categorias fixas do gráfico «Tipo de mudança» (backend: created, updated, revoked). */
export const CHANGE_TYPE_CATEGORIES = [
  { key: 'created', label: 'Criadas', color: '#2E7D32' },
  { key: 'updated', label: 'Atualizadas', color: '#1976D2' },
  { key: 'revoked', label: 'Revogadas', color: '#D32F2F' },
] as const;

/** Categorias do gráfico «Tipo de norma» (chaves = canonical_legislation_type no backend). */
export const LAW_TYPE_CATEGORIES = [
  { key: 'lei', label: 'Lei', color: '#1976D2' },
  { key: 'decreto', label: 'Decreto', color: '#7B1FA2' },
  { key: 'decreto-lei', label: 'Decreto-lei', color: '#5E35B1' },
  { key: 'portaria', label: 'Portaria', color: '#0288D1' },
  { key: 'resolução', label: 'Resolução', color: '#2E7D32' },
  { key: 'instrução normativa', label: 'Instrução normativa', color: '#F57C00' },
  { key: 'medida provisória', label: 'Medida provisória', color: '#D32F2F' },
  { key: 'ordem de serviço', label: 'Ordem de serviço', color: '#00897B' },
  { key: 'norma', label: 'Outras normas', color: '#9E9E9E' },
] as const;

export type ChartCategory = {
  key: string;
  label: string;
  color: string;
};
